import { useState } from 'react'

import { useDispatch, useSelector } from 'react-redux'
import emoji from 'react-easy-emoji'
import clsx from 'clsx'

import AddStar from 'app/components/icons/AddStar'
import styles from './styles.module.scss'
import { setFeedbackboxValues, submitFeedback } from 'app/redux/messages/messages.actions'
import StatusCard from 'app/components/StatusCard'

const getTexts = ({ widgetData }) => widgetData.widgetInfo.languageInfo.texts

function FeedbackBox({ rate, comment, teamId, agentId, conversationId, status }) {
  const [loadingSubmit, setLoadingSubmit] = useState(false)

  const texts = useSelector(getTexts)
  const dispatch = useDispatch()

  const successfullySubmited = status === 'success'
  const showStatusCard = !!status
  const isSubmitBtnDisabled = !rate && !comment

  const {
    rateConversation,
    thankForRating,
    thereWasProblemWithSavingYourDetails,
    excellentRating,
    goodRating,
    badRating,
    awefulRating,
    writeMore,
    submit,
  } = texts

  const ratingOptions = [
    { emoji: '😍', label: excellentRating, value: 1 },
    { emoji: '😀', label: goodRating, value: 2 },
    { emoji: '😔', label: badRating, value: 3 },
    { emoji: '😡', label: awefulRating, value: 4 },
  ]

  const STATUS_CARD_TEXTS = {
    success: thankForRating,
    failed: thereWasProblemWithSavingYourDetails,
  }

  const handleSubmit = () => {
    // if one request already sent do not send another!
    if (loadingSubmit) return

    setLoadingSubmit(false)

    dispatch(
      submitFeedback({
        rate,
        comment,
        agentId,
        conversationId,
        teamId,
        setLoadingSubmit,
      }),
    )
  }

  const handleChangeCommentInput = (e) => {
    dispatch(
      setFeedbackboxValues({
        teamId,
        conversationId,
        comment: e.target.value,
      }),
    )
  }

  const handleSelectRate = (rate) => {
    dispatch(
      setFeedbackboxValues({
        teamId,
        conversationId,
        rate,
      }),
    )
  }

  const renderRatingOptions = () => {
    return ratingOptions.map((item) => (
      <div key={item.value} className={styles.rating_box__emoji_container}>
        <span
          data-selected={item.value === rate}
          onClick={() => handleSelectRate(item.value)}
          className={styles.rating_box__emoji}
        >
          {emoji(item.emoji)}
        </span>
        <span className={clsx(styles.rating_status, 'raychat-font-bold')}>{item.label}</span>
      </div>
    ))
  }

  return (
    <div className={styles.feedback_box}>
      <div className={styles.feedback_box__header}>
        <AddStar className={styles.feedback_box__header_icon} />
        <span>{rateConversation}</span>
      </div>

      <div className={styles.feedback_box__body}>
        <div data-disabled={successfullySubmited} className={styles.rating_box}>
          {renderRatingOptions()}
        </div>

        <textarea
          onChange={handleChangeCommentInput}
          className={styles.feedback_box__comment_input}
          placeholder={writeMore}
          value={comment}
          type="text"
          disabled={successfullySubmited}
        />

        {showStatusCard && <StatusCard cardType={status} text={STATUS_CARD_TEXTS[status]} />}

        {!successfullySubmited && (
          <button disabled={isSubmitBtnDisabled} onClick={handleSubmit} className={styles.feedback_box__submit_btn}>
            {submit}
          </button>
        )}
      </div>
    </div>
  )
}

export default FeedbackBox
